module.exports = __webpack_public_path__ + "img/blue-cross.5a59d8ee.svg";